// Mock data for Global Tribe redo

export const brand = {
  name: "GLOBAL TRIBE",
  tagline: "Where Language Meets Revenue.",
  founder: "Arnab Pramanik",
  role: "Founder · IIMK Alumnus · Sales Strategist",
  email: "thearnabpramanik@gmail.com",
  phone: "+91 99900 23006",
  location: "India · Serving Globally"
};

export const stats = [
  { value: "$12M+", label: "High-Ticket Deals Closed" },
  { value: "2,400+", label: "Professionals Coached" },
  { value: "98%", label: "Pitch Conversion Uplift" },
  { value: "14+", label: "Years of Sales Craft" }
];

export const services = [
  {
    id: "udeva",
    tag: "UDEVA",
    title: "Urban Development of English, Voice & Accent",
    kicker: "Language as Leverage",
    description:
      "Niche voice, accent and productivity coaching for professionals who need to command the room \u2014 not just fill it.",
    bullets: [
      "Expert-level English with industry modules",
      "1:1 speech & pitch labs",
      "Skilled writing for high-stake decks",
      "Home-to-home and hybrid delivery"
    ],
    metric: "3x",
    metricLabel: "faster fluency vs. traditional coaching"
  },
  {
    id: "sos",
    tag: "SOS",
    title: "Science of Sales as a Service",
    kicker: "Close Bigger. Close Cleaner.",
    description:
      "The art of closures and high-ticket conversion, taught by an IIMK alum who has done million-dollar closings, not just talked about them.",
    bullets: [
      "Brand building for founders & operators",
      "High-ticket closing frameworks",
      "Customer development playbooks",
      "Push & pull go-to-market strategy"
    ],
    metric: "$1M+",
    metricLabel: "average deal size mentored"
  }
];

export const capabilities = [
  {
    title: "Brand Building",
    copy: "Design the presence that makes buyers pre-sold before the call.",
    icon: "Sparkles"
  },
  {
    title: "Corporate & Education Tie-ups",
    copy: "Institutional partnerships that turn your program into a pipeline.",
    icon: "Handshake"
  },
  {
    title: "Pitch Ready",
    copy: "From opening line to signed MSA \u2014 rehearsed, refined, revenue-ready.",
    icon: "Presentation"
  },
  {
    title: "Science of Sales",
    copy: "Repeatable frameworks that convert cold curiosity into closed contracts.",
    icon: "LineChart"
  },
  {
    title: "English Building",
    copy: "The 2% English that gets promoted, funded and quoted.",
    icon: "BookOpen"
  },
  {
    title: "High-Ticket Closing",
    copy: "Handle objections, price and silence with the confidence of an operator.",
    icon: "Target"
  }
];

export const timeline = [
  {
    year: "2010 \u2014 2013",
    title: "The Language Awakening",
    copy: "Personal transformation begins \u2014 adopting English as a breadth language and unlocking access to global rooms."
  },
  {
    year: "2015 \u2014 2020",
    title: "The Revenue Years",
    copy: "A series of startups and enterprise motions culminating in million-dollar closings and a Microsoft partner uplift."
  },
  {
    year: "2020 \u2014 2022",
    title: "The Hybrid Platform",
    copy: "Global Tribe is re-imagined \u2014 English Builders + Science of Sales, delivered on a hybrid, high-signal platform."
  },
  {
    year: "2023 \u2014 Now",
    title: "The 2% Tribe",
    copy: "Coaching operators, founders and closers who refuse to sound average and refuse to sell small."
  }
];

export const testimonials = [
  {
    name: "Ritika Sharma",
    role: "Founder, SaaS (Series A)",
    quote:
      "We rewrote our pitch with Arnab on a Sunday. Closed a $340K annual contract on Wednesday. It's not coaching, it's a revenue upgrade."
  },
  {
    name: "Kunal Mehta",
    role: "Enterprise AE, Fintech",
    quote:
      "The Science of Sales module made objections feel like invitations. My quota attainment moved from 71% to 138% in two quarters."
  },
  {
    name: "Ananya Iyer",
    role: "Product Lead, Global SI",
    quote:
      "UDEVA sharpened the way I speak in leadership rooms. Same ideas \u2014 suddenly people listen and act on them."
  }
];

export const portfolio = [
  {
    title: "UDEVA",
    subtitle: "Hybrid English Platform",
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=70"
  },
  {
    title: "English Builders",
    subtitle: "1:1 Live Coaching",
    image:
      "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?auto=format&fit=crop&w=1200&q=70"
  },
  {
    title: "Urban English",
    subtitle: "Corporate & Institutional Tie-ups",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=70"
  },
  {
    title: "Science Of Sales",
    subtitle: "High-Ticket Closing Cohort",
    image:
      "https://images.pexels.com/photos/5816300/pexels-photo-5816300.jpeg?auto=compress&cs=tinysrgb&w=1200"
  }
];

export const nav = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Journey", href: "#journey" },
  { label: "Contact", href: "#contact" }
];
